import camelize from 'camelcase-keys-deep';

export default class Fleet {
  constructor(data) {
    const props = camelize(data);
    // When the API embeds an association (`User` → `user`, `Vehicle` → `vehicles`)
    // the camelized key collides with a getter of this class. Those getters have
    // no setter, so assigning them throws and kills the saga that parses the
    // payload. The getters already resolve the record from the environment.
    Object.keys(props)
      .filter((key) => !(key in Fleet.prototype))
      .forEach((key) => {
        this[key] = props[key];
      });
  }

  get vehicles() {
    let response = [];
    if (this.id) {
      response = this.env().Vehicle.findAllBy('fleetId', this.id);
    }
    return response;
  }

  get user() {
    return this.userId ? this.env().User.findBy('id', this.userId) : null;
  }

  // get socialReason() {
  //   return this.socialReasonId ? this.env().SocialReason.findBy('id', this.socialReasonId) : null;
  // }
}
